import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  visit(event) {
    if (event.target.closest("a, button, input, select, textarea, label")) return

    window.Turbo.visit(this.urlValue)
  }

  visitWithKeyboard(event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault()
      window.Turbo.visit(this.urlValue)
    }
  }
}
